import type { ComponentSchema } from '../../../schema-types'
import { SECTION_STYLE_FIELDS } from '../../lightings/lightings-1/_builder-constants'

/** The store's live campaigns as cards (search, status filter, sort), then optionally its discounted products. */
export const schema: ComponentSchema = {
  type: 'offers-list',
  label: 'Offers list',
  description: 'Every running campaign as a card with its dates and days left, plus the discounted products.',
  supportedPages: ['offers', 'home'],
  variants: [{ id: 'v1', label: 'Offer cards' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Offers' },
    { key: 'subtitle', label: 'Subtitle', type: 'text', default: 'Every deal running in the store right now.' },
    { key: 'showCampaigns', label: 'Show campaigns', type: 'boolean', default: true },
    { key: 'emptyText', label: 'Text when no campaign is running', type: 'string', default: 'No offers are running right now. Check back soon.' },
    { key: 'showProducts', label: 'Show discounted products', type: 'boolean', default: true },
    { key: 'productsTitle', label: 'Products title', type: 'string', default: 'Discounted products', dependency: { field: 'showProducts', value: true } },
    { key: 'productsLimit', label: 'Number of products', type: 'number', default: 12, dependency: { field: 'showProducts', value: true } },
    ...SECTION_STYLE_FIELDS,
  ],
}
